import React from 'react';
import SingleBanner from '../modules/Banners/SingleBanner/SingleBanner';

function SingleBannerPage(){
  return <SingleBanner/>
}

export default SingleBannerPage;